import { useRef } from "react";
import { t } from "@/i18n-js/instance";
import { Search } from "../Search";
import { SelectedRecords } from "../SelectedRecords";

interface SelectionProps {
  disableSearch?: boolean;
  searchPlaceholder?: string;
}

export const Selection = ({
  searchPlaceholder,
  disableSearch,
}: SelectionProps) => {
  const selectionModalRef = useRef<HTMLDivElement | null>(null);

  return (
    <div ref={selectionModalRef} className="flex max-h-96 flex-col">
      <Search
        placeholder={
          searchPlaceholder || t("community_member_select.search_placeholder")
        }
        selectionModalRef={selectionModalRef}
        disableSearch={disableSearch}
      />
      <SelectedRecords />
    </div>
  );
};
